import authGraphQLRequest from "utils/authGraphQLRequest"

const toGraphQLInput = (obj: any): string => {
  if (typeof obj === "object" && obj !== null) {
    return `{${Object.entries(obj)
      .map(([key, value]) => `${key}: ${toGraphQLInput(value)}`)
      .join(", ")}}`;
  } else if (Array.isArray(obj)) {
    return `[${obj.map(toGraphQLInput).join(", ")}]`;
  } else if (typeof obj === "string") {
    return `"${obj}"`;
  } else {
    return String(obj); 
  }
};

export const getRolePermission = (
  page?: number,
  pageSize?: number,
  searchTexts? : string
): Promise<any> => {

  return new Promise((resolve, reject) => {
        let queryString = `{
  allRoles(page: ${page}, per_page: ${pageSize}, searchTexts: "${searchTexts}"){
  roles{
    id
    role_name
    api
    dashboard
    client
    organization
    payment
    payment_method
    user
    role
    subscription
    token
    payout
    super_admin
    settlement
    blacklist
    settings
    customers
    whitelist
    api_request_logs
    crypto
    kyc_velocity
    fiat
    audit_logs
  }
}
}`;
    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_roles'
    )
      .then((responseData) => {
        resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getSingleRole = (id: any): Promise<any> => {

  return new Promise((resolve, reject) => {
    let queryString = `{
        role(id:"${id}"){
          id
          role_name
          api
          dashboard
          client
          organization
          payment
          payment_method
          user
          role
          subscription
          token
          payout
          super_admin
          settlement
          blacklist
          settings
          customers
          whitelist
          api_request_logs
          crypto
          kyc_velocity
          fiat
          audit_logs
        }
      }
  `;

    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_roles'
    )
      .then((responseData) => {
        resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updateUserPermission = (data: any, id: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    let queryString = `
mutation {
  updateRole(id: "${id}", input: ${toGraphQLInput(data)}) {
    status
  }
}

    `;
    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_update_roles'
    )
      .then((responseData) => {
        resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const postUserPermission = (data: any): Promise<any> => {

  return new Promise((resolve, reject) => {
    let queryString = `
mutation {
  createRole(input: ${toGraphQLInput(data)}) {
    role {
      id
    }
  }
}

    `;

    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_create_roles'
    )
      .then((responseData) => {
        resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });

};

export const deleteRole = (id: string , role_id : any): Promise<any> => {
  return new Promise((resolve, reject) => {
    let queryString = `
mutation {
  deleteRole(id: "${id}" , role_id : "${role_id}") {
    status
    message
  }
}
  `;
    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_delete_roles'
    )
      .then((responseData) => {
        resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};